import { QTable, QTableBody, QTableCell, QTableRow, QSearchBar, QSharedFilters } from '@kw/quokka-ui';
import { useState, useEffect } from 'react';
import { Box } from '@mui/system';
import { useBeforeUnload } from 'react-router-dom';
import _ from 'lodash';
import { filterByQuery as filterBySearchQuery } from './utils/filterHelper';
import { GuardianRulesTable } from './GuardianRulesTable';
import { useReloadRestore } from './utils/useReloadRestore';

interface IProps {
  filtersConfig: object;
  analysisId: string;
  data: object;
}

export const FiltersAndTable = ({ filtersConfig, analysisId, data }: IProps) => {
  const [filteredByDropDown, setFilteredByDropDown] = useState(data);
  const [filteredBySearchBox, setFilteredBySearchBox] = useState(data);
  const [query, setQuery] = useState('');
  const { restoredSearchQuery, setRestoredSearchQuery, shouldRestore, setShouldRestore } = useReloadRestore();

  // Handlers for Drop-Down filters updates. The filters filter the original data
  // then invokes this handler. We set apply two setState calls so that we speed up the rendering time.
  const handleFilteredDataFromSelects = filteredData => {
    setFilteredByDropDown(filteredData);
    const newFilteredData = filterBySearchQuery(filteredData, query);
    setFilteredBySearchBox(newFilteredData);
  };

  // Handlers for SearchBar updates. The search bar invokes the handler with the updated query.
  const handleSearchQuery = e => {
    const value = e.target.value.toString();
    setQuery(value);
  };

  const removeSearchQuery = () => {
    setQuery('');
    setFilteredBySearchBox(filteredByDropDown);
  };

  const onSearch = value => {
    setQuery(value);
    const newFilteredData = filterBySearchQuery(filteredByDropDown, value);
    setFilteredBySearchBox(newFilteredData);
    setRestoredSearchQuery(value);
  };

  const handleKeyPress = e => {
    if (e.charCode === 13) {
      onSearch(e.target.value.toString());
    }
  };

  const onButtonSearch = () => {
    onSearch(query);
  };

  // Restore the search query from local storage
  useEffect(function restoreSearchQuery() {
    if (shouldRestore && restoredSearchQuery.length) {
      onSearch(restoredSearchQuery);
    }
  }, []);

  useBeforeUnload(() => {
    setShouldRestore(true);
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', minHeight: '100vh' }}>
      <QTable data-testid="rules-table">
        <QTableBody>
          <QTableRow hoverDisabled>
            <QTableCell sx={{ padding: '0px' }}>
              <Box
                sx={{
                  display: 'flex',
                  paddingBottom: '16px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignSelf: 'stretch',
                  zIndex: 1,
                }}
              >
                {/* THIS PREVENTS SETTING FILTERS */}
                <QSharedFilters originalData={data} filtersConfig={filtersConfig} onFilteredData={handleFilteredDataFromSelects} />
                <Box sx={{ px: '16px' }}>
                  <QSearchBar
                    onChange={handleSearchQuery}
                    searchValue={query}
                    onRemove={removeSearchQuery}
                    onKeyPress={handleKeyPress}
                    onButtonSearch={onButtonSearch}
                  />
                </Box>
              </Box>
            </QTableCell>
          </QTableRow>
        </QTableBody>
      </QTable>
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        <GuardianRulesTable data={filteredBySearchBox} analysisId={analysisId} />
      </Box>
    </Box>
  );
};
